import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { LoggerService } from "./logger.service";

@Injectable({ providedIn: "root" })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: LoggerService,
    private authService: AuthService
  ) {}

  handleError(error: any): void {
    const timestamp = new Date().toISOString();
    const user = this.authService.getCurrentUser()?.username || "anonymous";
    const errorMessage =
      error instanceof Error ? error.message : "Unknown error";
    const stackTrace = error instanceof Error ? error.stack : "No stack trace";

    // Log error details to the console for debugging
    console.error(`[${timestamp}] Error caught by GlobalErrorHandler:`, {
      user,
      errorMessage,
      stackTrace,
      error,
    });

    // Log error using LoggerService for structured logging
    this.logger.error("GlobalErrorHandler", `Error: ${errorMessage}`, {
      timestamp,
      user,
      stackTrace,
      error,
    });

    // Handle specific HTTP errors
    if (error instanceof HttpErrorResponse) {
      if (error.status === 401) {
        console.warn("Session expired (401)");
      } else if (error.status === 403) {
        console.warn(
          "Access denied (403). User does not have the required permissions."
        );
      }
    }
  }
}
